import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import PropTypes from "prop-types";
import parse from "html-react-parser";

function HfnPopup(props) {
  const { Button_Text: ButtonText, Content, Title, show: isVisible } = props;

  const [show, setShow] = useState(isVisible);

  return (
    <section className="Hfnpopup">
      <div
        className={`${Title}_wrapper`}
        onClick={() => setShow(true)}
        role="button"
        aria-hidden="true"
      >
        {parse(ButtonText) || ButtonText}
      </div>
      <Dialog
        visible={show}
        onHide={() => setShow(false)}
        maximizable
        className="HfnPopup_wrapper"
      >
        {parse(Content) || Content}
      </Dialog>
    </section>
  );
}

HfnPopup.defaultProps = {
  show: false,
  Button_Text: "<p>Click here</p>",
};

HfnPopup.propTypes = {
  /**
   * Title is wrapper for overall component
   * */
  Title: PropTypes.string.isRequired,
  /**
   * Button Text is Onclick Trigger for the Popup
   * */
  Button_Text: PropTypes.string,
  /**
   * Content is children for the Popup
   * */
  Content: PropTypes.string.isRequired,
  /**
   * Default visiblity for Popup  - True | false
   * */
  show: PropTypes.bool,
};

export default HfnPopup;
